//** NEW TEMPLATE
import React from "react";
import { withRouter } from "react-router-dom";

// COMPONENTS
import Layout from "../layout/Layout";
import Icon from "../icons/Icon";
import NewButton from "../buttons/NewButton";
import Title from '../text/Title';

const TogglePrompt = ({
  iconID,
  title,
  history,
  msg,
  url,
  view,
  btnText,
  hideButtons,
  callback,
  confirmer,
  style,
}) => {
  const handleButtonClick = () => {
    if (url) {
      history.push(url);
    } else if (callback) {
      callback();
    }
  };

 // @todo there is a confirmer component with this code check it out and see if this is a repetition
  if (confirmer)
    return (
      <div className={`__j bc1 c10`} style={style} data-name="TogglePrompt">
        <Layout flex>
          <div>{iconID && <Icon iconId={iconID} addClass="__j_i" />}</div>
          <div className="__j_c">
            {title && <Title addClass="__j_t">{!view ? title[0] : title[1]}</Title>}
            <p>{!view ? msg[0] : msg[1]}</p>
            {hideButtons && (
              <div className="__j_b">
                <NewButton value={!view ? btnText[0] : btnText[1]} onClick={handleButtonClick} />
              </div>
            )}
          </div>
        </Layout>
      </div>
    );

  return (
    <div className="__r br2" style={style} data-name="TogglePrompt" data-test="TogglePrompt">
      <p className={`__rt ${view ? "c4" : ""}`}>{!view ? msg[0] : msg[1]}</p>
      <NewButton
        toggle
        btnStyle="flat"
        colStyle={view ? "default" : "danger"}
        addClass="__rb"
        onClick={handleButtonClick}
      >
        {!view ? btnText[0] : btnText[1]}
      </NewButton>
    </div>
  );
};

export default withRouter(TogglePrompt);
